import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import { PriceBreakdown } from "../Detail/components/BookableItems";
import { useTravelers } from "../../../context/travelersContext";
import { getBookableItemPricingRecord } from "../Detail/components/availability-and-price-helpers";
import useExperienceData from "../../../hooks/useExperienceData";
import CancellationPolicy from "../Detail/components/CancellationPolicy";

interface OrderDetailsProps {
    isFormValid: boolean;
    handleSubmitNextStep: (event: React.MouseEvent) => void;
    nextStepLabel: string;
    handleCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    showTerms?: boolean;
}

const OrderDetails: React.FC<OrderDetailsProps> = ({
    isFormValid,
    handleSubmitNextStep,
    nextStepLabel,
    handleCheckboxChange,
    showTerms = false,
}) => {
    const { travelers, selectedDate, selectedItemCode } = useTravelers();
    const { experience } = useExperienceData()
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);

    dayjs.extend(customParseFormat);
    dayjs.extend(utc)

    useEffect(() => {
        const handleFocusIn = () => {
            if (window.innerWidth <= 768) {
                setIsKeyboardVisible(true);
            }
        };

        const handleFocusOut = () => {
            setIsKeyboardVisible(false);
        };

        document.addEventListener('focusin', handleFocusIn);
        document.addEventListener('focusout', handleFocusOut);

        return () => {
            document.removeEventListener('focusin', handleFocusIn);
            document.removeEventListener('focusout', handleFocusOut);
        };
    }, []);


    useEffect(() => {
        setIsSmallScreen(window.innerWidth <= 768);

        const handleResize = () => {
            setIsSmallScreen(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [isSmallScreen]);

    const bookableItem = experience?.availabilitySchedule.bookableItems.find(option => option.productOptionCode === selectedItemCode);
    const selectedProductOption = experience?.product.productOptions.find(option => option.productOptionCode === selectedItemCode);
    if (!bookableItem || !experience) return null;
    const currentPricingRecord = getBookableItemPricingRecord(bookableItem, selectedDate, travelers)
    if (!currentPricingRecord) return null

    return (
        <div className={`order-details__container ${isKeyboardVisible ? 'keyboard-visible' : ''}`}>
            <div className="order-price">
                <div className="h2">
                    <PriceBreakdown
                        bookableItem={bookableItem}
                    />
                </div>
            </div>
            <div className="order-description__container">
                <h3>{selectedProductOption?.title}</h3>
                {selectedProductOption?.description && <p dangerouslySetInnerHTML={{ __html: selectedProductOption.description }} />}
                {selectedDate}
                <CancellationPolicy
                    cancellationPolicy={experience.product.cancellationPolicy}
                />
            </div>
            {isSmallScreen && nextStepLabel && (
                <div className="checkout-actions checkout-actions--mobile">
                    {showTerms && (
                        <div className="checkbox">
                            <input type="checkbox" onChange={handleCheckboxChange}></input>
                            <label>
                                {/* eslint-disable-next-line */}
                                Acepto <a href="https://trippromoter.com/terminos-y-condiciones/" rel="noreferrer"
                                    target="_blank">los términos y condiciones</a>
                            </label>
                        </div>
                    )}
                    <button type="button" onClick={handleSubmitNextStep} disabled={!isFormValid}>
                        {nextStepLabel}
                    </button>
                </div>
            )}
        </div>
    );
};

export default OrderDetails;
